export default __webpack_public_path__ + "static/media/down.abf084ed.svg";